import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LayoutComponent } from './shared/layout/layout.component';
import { ComingSoonPageComponent } from './pages/others/coming-soon/coming-soon.component';
import { IndexComponent } from './pages/home/index/index.component';

import { PdfViewerComponent } from './pages/pdf-viewer/pdf-viewer.component';


const routes: Routes = [
	{
		path: 'pages/coming-soon',
		component: ComingSoonPageComponent
	},
	// ── NUOVA ROUTE (stabile, per QR code) ───────────────────────────────────
	// Esempio URL: /view-pdf/PDF/2835-120-SIL-POWER
	//              /view-pdf/MAN/2835-120-SIL-POWER
	{
		path: 'view-pdf/:codTipo/:codWeb',
		component: PdfViewerComponent
	},

	// ── VECCHIA ROUTE (retrocompatibilità, per QR già stampati in circolazione) ──
	// Esempio URL: /view-pdf/32026
	{
		path: 'view-pdf/:id',
		component: PdfViewerComponent
	},
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: '',
				pathMatch: 'full',
				component: IndexComponent
			},
			{
				path: 'pages',
				loadChildren: () => import('./pages/others/pages.module').then(m => m.PagesModule)
			},
			{
				path: 'shop',
				loadChildren: () => import('./pages/shop/shop.module').then(m => m.ShopModule)
			},
			{
				path: 'product',
				loadChildren: () => import('./pages/product/product.module').then(m => m.ProductModule)
			}
		]
	},
	{
		path: '**',
		redirectTo: '/pages/404'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: false, anchorScrolling: 'disabled', scrollPositionRestoration: 'disabled' })],
	exports: [RouterModule]
})

export class AppRoutingModule { }